import { z } from "zod";

// Free-text authored by a USER (coach or athlete), carried in every
// supported locale with each one independently optional. Same factory
// pattern as `slugString(max)` in ./slug.ts: one shape, one place, and
// only the per-field ceiling varies between call sites.
//
// Every locale is optional BY DESIGN — the author writes in their own
// language and owes no translation. That is the contract difference
// with `LocalizedText` (../localizedText.ts), which requires `en`
// because it describes content WE author and ship in the bundle.
// Requiring `en` here would force an Italian coach to write English
// before they could save.
//
// An object with no locale at all is a legal parse result here; the
// "at least one language" rule belongs to the fields that declare
// themselves mandatory and lives in ../authoredText.ts, which also adds
// the machine-translation marker.
export const localizedOptionalText = (max: number) =>
  z.object({
    en: z.string().min(1).max(max).optional(),
    it: z.string().min(1).max(max).optional(),
    fr: z.string().min(1).max(max).optional(),
    de: z.string().min(1).max(max).optional(),
    ru: z.string().min(1).max(max).optional(),
  });
